import React, { useState } from 'react';
import { uploadService } from '../services/api';
import '../styles/ImageUploader.css';

const ImageUploader = ({ onImageUploaded, multiple = false }) => {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState([]);

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) return;

    // Crear previews
    const previews = files.map(file => URL.createObjectURL(file));
    setPreview(previews);

    setUploading(true);

    try {
      const formData = new FormData();

      if (multiple) {
        files.forEach(file => {
          formData.append('imagenes', file);
        });
        const response = await uploadService.subirImagenes(formData);
        onImageUploaded(response.data.imagenes);
      } else {
        formData.append('imagen', files[0]);
        const response = await uploadService.subirImagen(formData);
        onImageUploaded(response.data.url);
      }

      // Limpiar previews después de subir
      setTimeout(() => {
        setPreview([]);
      }, 2000);

    } catch (error) {
      console.error('Error al subir imagen:', error);
      alert(error.response?.data?.error || 'Error al subir imagen');
      setPreview([]);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="image-uploader">
      <label className="upload-label">
        <input
          type="file"
          accept="image/*"
          multiple={multiple}
          onChange={handleFileChange}
          disabled={uploading}
        />
        <div className="upload-button">
          {uploading ? (
            <>⏳ Subiendo...</>
          ) : (
            <>📷 {multiple ? 'Seleccionar imágenes' : 'Seleccionar imagen'}</>
          )}
        </div>
      </label>

      {preview.length > 0 && (
        <div className="preview-container">
          {preview.map((url, index) => (
            <img key={index} src={url} alt={`Preview ${index + 1}`} className="preview-image" />
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageUploader;
